import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../app/store';
import {
  isAnulada,
  isLoading,
  loadDataSolicitud,
  loadListSolicitud,
  setVolver,
  showMessage,
} from '../context/Solicitud/SolicitudReducer';
import solicitudInitial from '../context/Solicitud/SolicitudReducer';
import { Solicitud } from '../classes/Solicitud';
import { Dispatch } from 'react';
import {
  findAll,
  get,
  save,
  update,
  cargarCombo,
} from '../services/Service';
import { useNavigate } from 'react-router-dom';
import { CondicionNormativa, MarcoLegal } from '../types/Normativa';
import { DatosGeneralesForm } from '../types/DatosGenerales';
import moment from 'moment';
import { toast } from 'react-toastify';
import api from '../api/api';
import { logger } from '../utils/logger';

export const useSolicitud = () => {
  const BASE_URL = 'solicitudes';
  const navigate = useNavigate();

  const {
    solicitudes,
    solicitudSelected,
    loading,
    message,
    anulada,
    urlVolver,
  } = useSelector((state: RootState) => state.solicitud);
  const dispatch = useDispatch();

  const buscarSolicitudes = async (solicitud: Solicitud) => {
    await search(solicitud)
      .then((response) => {
        dispatch(loadListSolicitud(response.data));
      })
      .catch((error) => {
        logger.log(logger.safeError(error));
      });
  };

  const bandejaTrabajo = async () => {
    await findAll(`${BASE_URL}/bandeja-trabajo`)
      .then((response) => {
        dispatch(loadListSolicitud(response.data));
      })
      .catch((error) => {
        logger.log(logger.safeError(error));
      });
  };

  const buscarSolicitud = async (id: string) => {
    await get(BASE_URL, id)
      .then((response) => {
        dispatch(loadDataSolicitud(response.data));
      })
      .catch((error) => {
        logger.log(logger.safeError(error));
      });
  };

  const cargarEmpresasGestoras = async (
    path: string,
    idContratista: string,
    setStateFunc: Dispatch<React.SetStateAction<any>>
  ) => {
    try {
      // Verificar si idContratista es válido
      if (
        !idContratista ||
        idContratista === 'null' ||
        idContratista === 'undefined'
      ) {
        logger.warn('idContratista no válido:', idContratista);
        setStateFunc([]);
        return;
      }

      const response = await findAll(
        `${path}/find?idContratista=${idContratista}`
      );

      if (response && response.data) {
        setStateFunc(response.data);
      } else {
        logger.warn(`No data received for: ${path}`);
        setStateFunc([]);
      }
    } catch (error) {
      logger.error(`Error loading ${path}:`, logger.safeError(error));
      setStateFunc([]);
    }
  };

  const cargarEmpresasGestorasByTipoUsuario = async (
    idUsuario: string,
    setStateFunc: Dispatch<React.SetStateAction<any>>
  ) => {
    try {
      // Verificar si idUsuario es válido
      if (
        !idUsuario ||
        idUsuario === 'null' ||
        idUsuario === 'undefined'
      ) {
        logger.warn('idUsuario no válido:', idUsuario);
        setStateFunc([]);
        return;
      }

      const response = await findAll(
        `empresasGestoras/findByTipoUsuario?idUsuario=${idUsuario}`
      );

      if (response && response.data) {
        setStateFunc(response.data);
      } else {
        logger.warn('No data received for empresas gestoras');
        setStateFunc([]);
      }
    } catch (error) {
      logger.error('Error loading empresas gestoras:', logger.safeError(error));
      setStateFunc([]);
    }
  };

  const cargarContratistasByTipoUsuario = async (
    idUsuario: string,
    setStateFunc: Dispatch<React.SetStateAction<any>>
  ) => {
    try {
      // Verificar si idUsuario es válido
      if (
        !idUsuario ||
        idUsuario === 'null' ||
        idUsuario === 'undefined'
      ) {
        logger.warn('idUsuario no válido:', idUsuario);
        setStateFunc([]);
        return;
      }

      const response = await findAll(
        `contratistas/byTipoUsuario?idUsuario=${idUsuario}`
      );

      if (response && response.data) {
        setStateFunc(response.data);
      } else {
        logger.warn('No data received for contratistas');
        setStateFunc([]);
      }
    } catch (error) {
      logger.error('Error loading contratistas:', logger.safeError(error));
      setStateFunc([]);
    }
  };
  const cargarContratistas = async (
    path: string,
    idEmpresaGestora: string,
    setStateFunc: Dispatch<React.SetStateAction<any>>
  ) => {
    await findAll(`${path}/find?idEmpresaGestora=${idEmpresaGestora}`)
      .then((response) => {
        setStateFunc(response.data);
      })
      .catch((error) => {
        logger.log(logger.safeError(error));
      });
  };

  const handleInitSolicitud = async (solicitud: Solicitud) => {
    try {
      const result = await save(BASE_URL, solicitud);
      dispatch(loadDataSolicitud(result.data));
      navigate(`/solicitud/${result.data.id}?create=true`);
    } catch (error) {
      logger.log(logger.safeError(error));
    }
  };

  const handleSolicitudSelected = (solicitud: Solicitud) => {
    dispatch(loadDataSolicitud(solicitud));
  };
  const handleLoading = (load: boolean) => {
    dispatch(isLoading(load));
  };
  const handleShowMessage = (load: boolean) => {
    dispatch(showMessage(load));
  };
  const handleAnulada = (load: boolean) => {
    dispatch(isAnulada(load));
  };

  const search = async (entity: any) => {
    try {
      const fechaInicio =
        entity.fechaInicio === '' || entity.fechaInicio === null
          ? ''
          : moment(entity.fechaInicio).format('YYYY-MM-DD');
      const fechaFin =
        entity.fechaFin === '' || entity.fechaFin === null
          ? ''
          : moment(entity.fechaFin).format('YYYY-MM-DD');
      const response = await findAll(
        `${BASE_URL}/find?numeroSolicitud=${entity.numeroSolicitud}&numeroContrato=${entity.numeroContrato}&idTipoTrabajo=${entity.idTipoTrabajo}&idTipoEstado=${entity.idTipoEstado}&idEmpresaGestora=${entity.idEmpresaGestora}&idContratista=${entity.idContratista}&idInstalacion=${entity.idInstalacion ?? ''}&fechaInicio=${fechaInicio}&fechaFin=${fechaFin}`
      );
      return response;
    } catch (error) {
      logger.error(logger.safeError(error));
      throw error;
    }
  };

  const mapSolicitudToDatosGenerales = (
    solicitud: Solicitud
  ): DatosGeneralesForm => {
    // Mapear los campos que tengan el mismo nombre
    const datosGenerales: DatosGeneralesForm = {
      id: solicitud.id,
      numeroContrato: solicitud.numeroContrato
        ? solicitud.numeroContrato.toString()
        : '', // Asegurarse de que sea un string
      idInstalacion: solicitud.idInstalacion
        ? solicitud.idInstalacion.toString()
        : '', // Asegurarse de que sea un string
      numeroMatricula: solicitud.numeroMatricula
        ? solicitud.numeroMatricula.toString()
        : '', // Agregar el campo numeroMatricula
      infoAdicional: solicitud.infoAdicional || '',
      fechaInicio: solicitud.fechaInicio
        ? moment(solicitud.fechaInicio, 'YYYY-MM-DD').toDate()
        : null, // Manejar nulos si es necesario
      fechaFin: solicitud.fechaFin
        ? moment(solicitud.fechaFin, 'YYYY-MM-DD').toDate()
        : null, // Manejar nulos si es necesario
      fechaAsignacion: solicitud.fechaAsignacion
        ? moment(solicitud.fechaAsignacion, 'YYYY-MM-DD').toDate()
        : null, // Manejar nulos si es necesario
    };
    return datosGenerales;
  };

  const sendSolicitud = async (idSolicitud: number) => {
    try {
      const response = await get(
        `${BASE_URL}/send`,
        idSolicitud.toString()
      );
      handleSolicitudSelected(response.data);
      return response.data;
    } catch (error: any) {
      if (error.response && error.response.status === 400) {
        toast.error(error.response.data.message);
      } else if (error.response && error.response.status === 500) {
        toast.error(error.response.data.message);
      } else if (error.response?.status === 401) {
        toast.error(error.response.data.message);
      } else {
        toast.error(error.response.data.message);
        throw error;
      }
      logger.error(logger.safeError(error));
    }
  };

  const updateSolicitud = async (solicitud: any) => {
    try {
      logger.log('🔄 [UPDATE] Actualizando solicitud, id:', solicitud?.id);
      const response = await update(`${BASE_URL}`, solicitud);
      logger.log('✅ [UPDATE] Respuesta recibida, status:', response.status);

      // Si la respuesta no incluye todos los datos necesarios (como idEmpresaGestora),
      // volver a buscar la solicitud completa
      if (
        response.data.id &&
        (!response.data.idEmpresaGestora ||
          !response.data.idContratista)
      ) {
        logger.log(
          '⚠️  [UPDATE] Respuesta incompleta, buscando solicitud completa...'
        );
        const fullResponse = await get(
          BASE_URL,
          response.data.id.toString()
        );
        logger.log('✅ [UPDATE] Solicitud completa obtenida, id:', fullResponse.data?.id);
        handleSolicitudSelected(fullResponse.data);
        return fullResponse;
      } else {
        handleSolicitudSelected(response.data);
        return response;
      }
    } catch (error) {
      logger.error('❌ [UPDATE] Error:', logger.safeError(error));
      throw error;
    }
  };
  const validarCalificarSolicitud = async (idSolicitud: number) => {
    try {
      const response = await get(
        `${BASE_URL}/validar-calificar`,
        idSolicitud.toString()
      );
      return response.data;
    } catch (error: any) {
      if (error.response && error.response.status === 400) {
        toast.error(error.response.data.message);
      } else if (error.response && error.response.status === 500) {
        toast.error(error.response.data.message);
      } else if (error.response?.status === 401) {
        toast.error(error.response.data.message);
      } else {
        toast.error(error.response.data.message);
        throw error;
      }
      logger.error(logger.safeError(error));
    }
  };

  const validarDocumentosAprobados = async (idSolicitud: number) => {
    try {
      const response = await get(
        `${BASE_URL}/validar-aprobados`,
        idSolicitud.toString()
      );
      return response.data;
    } catch (error: any) {
      if (error.response && error.response.status === 400) {
        toast.error(error.response.data.message);
      } else if (error.response && error.response.status === 500) {
        toast.error(error.response.data.message);
      } else if (error.response?.status === 401) {
        toast.error(error.response.data.message);
      } else {
        toast.error(error.response.data.message);
        throw error;
      }
      logger.error(logger.safeError(error));
    }
  };

  const cargarInstalaciones = async (
    path: string,
    idEmpresaGestora: number,
    setStateFunc: Dispatch<React.SetStateAction<any>>,
    mapFn?: (value: any, index: number, array: any[]) => any
  ) => {
    await findAll(`${path}/find?idEmpresaGestora=${idEmpresaGestora}`)
      .then((response) => {
        const resp =
          mapFn != null ? response.data.map(mapFn) : response.data;
        setStateFunc(resp);
      })
      .catch((error) => {
        logger.log(logger.safeError(error));
      });
  };
  const handleUrlVolver = (url: string) => {
    dispatch(setVolver(url));
  };

  const cargarTipoTrabajo = async (
    path: string,
    idEmpresaGestora: string,
    idContratista: string,
    setStateFunc: Dispatch<React.SetStateAction<any>>
  ) => {
    await findAll(
      `${path}/find?idEmpresaGestora=${idEmpresaGestora}&idContratista=${idContratista}`
    )
      .then((response) => {
        setStateFunc(response.data);
      })
      .catch((error) => {
        logger.log(logger.safeError(error));
      });
  };
  const cargarTipoTrabajoAltoRiesgo = async (
    path: string,
    idEmpresaGestora: string,
    idContratista: string,
    setStateFunc: Dispatch<React.SetStateAction<any>>
  ) => {
    await findAll(
      `${path}/altoRiesgo/find?idEmpresaGestora=${idEmpresaGestora}&idContratista=${idContratista}`
    )
      .then((response) => {
        setStateFunc(response.data);
      })
      .catch((error) => {
        logger.log(logger.safeError(error));
      });
  };

  const cargarTipoBajoRiesgo = async (
    path: string,
    idEmpresaGestora: string,
    idContratista: string,
    setStateFunc: Dispatch<React.SetStateAction<any>>
  ) => {
    await findAll(
      `${path}/bajoRiesgo/find?idEmpresaGestora=${idEmpresaGestora}&idContratista=${idContratista}`
    )
      .then((response) => {
        setStateFunc(response.data);
      })
      .catch((error) => {
        logger.log(logger.safeError(error));
      });
  };

  const cargarOtrosTrabajos = async (
    path: string,
    idEmpresaGestora: string,
    idContratista: string,
    setStateFunc: Dispatch<React.SetStateAction<any>>
  ) => {
    await findAll(
      `${path}/otrosTrabajos/find?idEmpresaGestora=${idEmpresaGestora}&idContratista=${idContratista}`
    )
      .then((response) => {
        setStateFunc(response.data);
      })
      .catch((error) => {
        logger.log(logger.safeError(error));
      });
  };

  const esConAnalisisRiesgo = async (idEG: number) => {
    try {
      const response = await get(
        BASE_URL,
        `eg-con-riesgo?idEG=${idEG}`
      );
      return response.data;
    } catch (error) {
      return false;
    }
  };

  const esRiesgoBajo = async (idSolicitud: number) => {
    try {
      const response = await get(
        `${BASE_URL}/riesgo-bajo`,
        idSolicitud.toString()
      );
      return response.data;
    } catch (error) {
      logger.error('Error verificando si es riesgo bajo:', logger.safeError(error));
      return false;
    }
  };

  const obtenerMarcoLegalTiposTrabajo = async (
    tiposTrabajoIds: number[]
  ) => {
    try {
      const response = await findAll(
        `tiposTrabajos/marco-legal?ids=${tiposTrabajoIds.join(',')}`
      );
      return response.data;
    } catch (error) {
      logger.error('Error obteniendo marco legal:', logger.safeError(error));
      return [];
    }
  };

  const obtenerCondicionesNormativaTiposTrabajo = async (
    tiposTrabajoIds: number[]
  ) => {
    try {
      const response = await findAll(
        `tiposTrabajos/condicion-normativa?ids=${tiposTrabajoIds.join(
          ','
        )}`
      );
      return response.data;
    } catch (error) {
      logger.error(
        'Error obteniendo condiciones normativas:',
        logger.safeError(error)
      );
      return [];
    }

    // Datos dummy temporales basados en la imagen
    // return [
    //   {
    //     id: 1,
    //     tipo: 'FISICA',
    //     descripcion:
    //       'Delimitar el área de trabajo y señalizar las zonas con riesgo de caída. Prohibición de superposición de tareas en plano vertical.',
    //   },
    //   {
    //     id: 2,
    //     tipo: 'FISICA',
    //     descripcion:
    //       'Uso obligatorio de arnés de seguridad a más de 1,80 metros y dispositivo antitrauma a más de 6 metros, ambos en buen estado',
    //   },
    //   {
    //     id: 3,
    //     tipo: 'ADMINISTRATIVA',
    //     descripcion:
    //       'Cumplir con los requisitos reglamentarios de aptitud física y salud, incluyendo estudio de equilibrio y examen médico.',
    //   },
    //   {
    //     id: 4,
    //     tipo: 'ADMINISTRATIVA',
    //     descripcion:
    //       'Capacitación específica y obligatoria para trabajos en altura.',
    //   },
    // ];
  };

  const aceptarDeclaracionJurada = async (
    idSolicitud: number,
    aceptacion: boolean
  ) => {
    try {
      const response = await api.put(
        `${BASE_URL}/ddjj?id=${idSolicitud}&aceptacionDDJJ=${aceptacion}`
      );
      handleSolicitudSelected(response.data);
      return response.data;
    } catch (error: any) {
      if (error.response && error.response.status === 400) {
        toast.error(error.response.data.message);
      } else if (error.response && error.response.status === 500) {
        toast.error(error.response.data.message);
      } else {
        toast.error('Error al procesar la declaración jurada');
      }
      logger.error(logger.safeError(error));
      throw error;
    }
  };

  return {
    solicitudInitial,
    solicitudes,
    buscarSolicitudes,
    buscarSolicitud,
    cargarCombo,
    solicitudSelected,
    handleSolicitudSelected,
    loading,
    handleLoading,
    cargarTipoTrabajo,
    handleInitSolicitud,
    updateSolicitud,
    mapSolicitudToDatosGenerales,
    sendSolicitud,
    validarCalificarSolicitud,
    message,
    handleShowMessage,
    anulada,
    handleAnulada,
    cargarInstalaciones,
    cargarEmpresasGestoras,
    cargarEmpresasGestorasByTipoUsuario,
    cargarContratistas,
    cargarContratistasByTipoUsuario,
    validarDocumentosAprobados,
    bandejaTrabajo,
    urlVolver,
    handleUrlVolver,
    cargarOtrosTrabajos,
    cargarTipoTrabajoAltoRiesgo,
    cargarTipoBajoRiesgo,
    esConAnalisisRiesgo,
    esRiesgoBajo,
    obtenerMarcoLegalTiposTrabajo,
    obtenerCondicionesNormativaTiposTrabajo,
    aceptarDeclaracionJurada,
  };
};
